import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'navy' | 'gold' | 'green' | 'amber' | 'red';

const toneClasses: Record<BadgeTone, string> = {
  neutral: 'bg-background-100 text-foreground-600 border-background-200',
  navy: 'bg-primary-50 text-primary-700 border-primary-200',
  gold: 'bg-accent-100 text-accent-800 border-accent-200',
  green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  amber: 'bg-amber-50 text-amber-700 border-amber-200',
  red: 'bg-red-50 text-red-700 border-red-200',
};

export function statusTone(status: string): BadgeTone {
  const s = status.toLowerCase();
  if (s.includes('onay')) return 'green';
  if (s.includes('tamam')) return 'green';
  if (s.includes('kapandı')) return 'green';
  if (s.includes('red')) return 'red';
  if (s.includes('iptal')) return 'neutral';
  if (s.includes('ulaşı')) return 'red';
  if (s.includes('revize')) return 'gold';
  if (s.includes('cevap')) return 'amber';
  if (s.includes('video geldi')) return 'gold';
  if (s.includes('video')) return 'amber';
  if (s.includes('gönderildi')) return 'amber';
  if (s.includes('değerlendir')) return 'navy';
  if (s.includes('hazırlanacak')) return 'navy';
  if (s.includes('hazırlandı')) return 'navy';
  if (s.includes('hazırlanmadı')) return 'navy';
  if (s.includes('taslak')) return 'neutral';
  if (s.includes('başladı')) return 'gold';
  if (s.includes('devam')) return 'gold';
  if (s.includes('yola')) return 'navy';
  if (s.includes('varıldı')) return 'navy';
  if (s.includes('yeni')) return 'neutral';
  if (s.includes('planlandı')) return 'neutral';
  return 'neutral';
}

export function priorityTone(priority: string): BadgeTone {
  if (priority === 'Yüksek') return 'red';
  if (priority === 'Orta') return 'amber';
  return 'neutral';
}

export default function Badge({
  tone = 'neutral',
  children,
  className = '',
}: {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-semibold ${toneClasses[tone]} ${className}`}
    >
      {children}
    </span>
  );
}